// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".placeholder[data-v-1512346f]{font-size:12px;color:var(--el-text-color-secondary)}", ""]);
// Exports
module.exports = exports;
